import { globals, variables } from '@setplex/arcane'
import { JSX, useLayoutEffect, type ReactNode } from 'react'

import '@setplex/arcane/styles.css'

interface Props {
  children: ReactNode
}

/**
 * Not actually a _context_ provider, just wrapper for styling
 */

ThemeProvider.displayName = 'ThemeProvider'
export function ThemeProvider({ children }: Props): JSX.Element {
  useLayoutEffect(() => document.body.classList.add(variables), [])
  return <div className={`${globals} ${variables}`}>{children}</div>
}
